/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'

const state = {
    pullOutToClients: {},
    pullOutToClient: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedPullOutToClients(state, payload) {
        let query = ''
        !payload.query ? query : query = payload.query

        state.isLoadingTable = true
        axios.get(`api/pullouttoclients/page=${payload.page}&pageSize=${payload.pageSize}/${query}`).then(response => {
            response.data.data.forEach(pullOut=>{
                pullOut.dateCreated = moment(pullOut.dateCreated).format('MM/DD/YYYY HH:mm')
                pullOut.date = moment(pullOut.date).format('MM/DD/YYYY')
            })

            state.pullOutToClients = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.pullOutToClient) {
            state.pullOutToClient = payload.pullOutToClient
        } else {
            state.pullOutToClient = {}
        }
    }
}

const actions = {
    getPaginatedPullOutToClients({
        commit
    }, payload) {
        commit('getPaginatedPullOutToClients', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}